import React from 'react'

export default function TextDivider({ text = '', className = '' }) {
  return (
    <div className={`relative my-5 text-center ${className}`}>
      <div className="absolute inset-x-0 top-1/2 border-t border-mauve-200" />
      <span className="relative bg-white px-3 text-sm text-mauve-500">
        {text}
      </span>
    </div>
  )
}
